import * as DialogPrimitive from "@radix-ui/react-dialog";
import { FC } from "react";
import { Dialog, DialogClose, DialogOverlay, DialogPortal } from "./Dialog";
import XIcon from "@src/lib/icons/12px/x";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imageUrl: string | null | undefined;
};

/**
 * Full-screen image preview dialog. Uses a raw `DialogPrimitive.Content`
 * (instead of the shared `DialogContent`) so it can escape the z-index of the
 * dialog that opened it.
 */
const ImagePreviewDialog: FC<Props> = ({ open, onOpenChange, imageUrl }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogPortal>
      <DialogOverlay className="z-[9998]" />
      <DialogPrimitive.Content
        data-testid="preview-dialog-content"
        onClick={(e) => e.stopPropagation()}
        className="fixed top-1/2 left-1/2 z-[9999] grid w-full max-w-[90vw] -translate-x-1/2 -translate-y-1/2 gap-4 border bg-background p-0 shadow-lg duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:rounded-lg"
      >
        <DialogPrimitive.Title className="sr-only">
          Image preview
        </DialogPrimitive.Title>
        <div className="relative flex items-center justify-center p-4">
          <img
            src={imageUrl || ""}
            alt="Preview"
            className="max-h-[85vh] max-w-full rounded-lg object-contain"
          />
        </div>
        <DialogClose className="absolute top-4 right-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-none disabled:pointer-events-none">
          <XIcon />
          <span className="sr-only">Close</span>
        </DialogClose>
      </DialogPrimitive.Content>
    </DialogPortal>
  </Dialog>
);

export default ImagePreviewDialog;
